import React from 'react';
import Wrp from "../../../hoc/Wrp/Wrp";
import Icons from '../../../Components/Icons/Icons';
import DropDownSearch from '../../../Components/DropDownSearch';

const InputConfig = (props) => {
	const {metaInfo,windowFields,windowFieldsBack,variableList,constantList,drillDownNextLevel,drillData,
		drillDownPrevLevel,goBackDrillDown,expressionChangeHandler,processLinesFields,selectedWindow,relatedWindowFields,assignToKeywordToggleModel,expression_error,outputInnerFields} = props;
	const {inputField,operator,outputField,expression,outputFieldMapping} = processLinesFields.mappingFields;

	let windowList = [];
 	if(relatedWindowFields && relatedWindowFields.window_fields) {
        Object.keys(relatedWindowFields.window_fields).map(function(key) {
            windowList.push(key);
        })      
    }

    let fieldOptions = [{label: "~None~", value: ""}];
    if(relatedWindowFields && relatedWindowFields.window_fields) {
        windowList.map((windArr,windInd) => {
            let label = '';
            let options = [];
            label = windArr;
            relatedWindowFields.window_fields[windArr].map((field,ind) => {
                options.push({label: field.field_name, value: field.id,fieldtype:field.field_type})
            })
            fieldOptions.push({label:label,options:options})
        })
    }

    // console.log(fieldOptions,relatedWindowFields)
	const fieldChangeHandler = (e,fData) => {
	    const {name,value} = e.target;
	    let fAbsWind = '';
	    let isSubForm = false;

	    if(drillData) {
	      drillData.map((arr,ind) => {
	        if(arr.is_subform && arr.is_subform === true) {
	          fAbsWind += ind === 0 ? arr.field_name : '.'+arr.field_name;
	        }else{
	          fAbsWind += ind === 0 ? arr.lookup_window_name : '.'+arr.lookup_window_name;
	        }
	        
	        if(arr.is_subform && arr.is_subform === true) {
	          isSubForm = true;
	        }
	      })  
	    }
	    let val = value;
	    if(fAbsWind !== '') {
	      val = fAbsWind+'.'+value;
	    }
	    if(isSubForm === true) {
	      val = val+'#n'
	    }
	    expressionChangeHandler("inputField",val);
  	}

  	const changeHandler = (e) => {
  		const {name,value} = e.target;
  		expressionChangeHandler(name,value);
  	}

  	const select2ChangeHandler = (value,name) => {
  		console.log(value,name)
  		expressionChangeHandler(name,value);
  	}

  	const addExpression = () => {
	    let exp = expression ? expression : '';

	    var myElement = document.getElementById('expressText');
	    var startPosition = myElement.selectionStart;
	    var endPosition = myElement.selectionEnd;

	    let textBeforeCursorPosition = exp.substring(0, startPosition)
	    let textAfterCursorPosition = exp.substring(startPosition, exp.length)
	    
	    let existVal = (expression !== undefined && expression !== null) ? expression : '';

	    let fields = inputField;
	    if(fields && fields !== '') {
	      fields = '${'+selectedWindow+'.'+fields+'}';
	    }else {
	      fields = '';
	    }

	    let outVar = '';//outputField;
	    if(drillData && drillData.length>0) {
	    	drillData.map((item,ind) => {
	    		outVar += ind === 0 ? item.api_name : '.'+item.api_name;
	    	})
	    	outVar += '.'+outputField;
	    }else {
	    	outVar = outputField
	    }
	    
	    if(outVar && outVar !== '') {
	      outVar = '@{'+outVar+'}';
	    }else {
	      outVar = '';
	    }

	    let val = '';
	    let operatorVal = operator;
	    if(operatorVal && operatorVal !== '') {
	      operatorVal = operatorVal;
	      val =  fields +operatorVal+''+ outVar+'';
	    }else {
	      operatorVal = '';
	      val =  fields +operatorVal+ outVar;
	    }
	    
	    const val1 = textBeforeCursorPosition + val + textAfterCursorPosition;
	    expressionChangeHandler("expression",val1,true);
  	}

  	let fieldVal = '';
	if(inputField) {
		const fieldSp = inputField.split('.');
		fieldVal = fieldSp[fieldSp.length-1]
		fieldVal = fieldVal.replace("$n",'');
	}

	let outputFields = [];
	outputFields.push.apply(outputFields, variableList);
	outputFields.push.apply(outputFields, constantList);

	if(outputFields && outputFields.length>0) {
    	let options = [];
    	outputFields.map((outputFieldItem, outputFieldIndex) => {
    		options.push({label: outputFieldItem.variable_name, value: outputFieldItem.id,fieldtype:""})
    	})
    	fieldOptions.push({label:"Others",options:options})
    }

	// console.log(outputFields,drillData);
	return (
		<div className="col-12 mb-2">
			<div className="card-outer">
				<div className="card-header cursor-pointer sectionHeader pl-1 p-2 position-relative">
					<div className="card-title d-flex align-items-center justify-content-between" id="card329a2e5d-1e03-41e2-bc8b-632548fdb2aa" data-toggle="collapse" href="#329a2e5d-1e03-41e2-bc8b-632548fdb2aa">
						<h6 className="mb-0"> Input / Output Config  </h6>
						<div className="span-mode"></div>
					</div>
				</div>
				<div className="form-body py-2 show" id="329a2e5d-1e03-41e2-bc8b-632548fdb2aa">
					<div className="row">
						<div className="col-12">
							 <div className="d-flex justify-content-between">
							    <div className="col-5 pr-0">
							        <div className="card mb-0">
							            <div className="card-header p-1">
							            	<div className="card-title">List of Input Fields</div>
							            	<ul className="breadcrumbs text-small">
						                      <li onClick={e=>goBackDrillDown(-1)}  className="nav-item">
						                        <a className=""> Windows</a>
						                      </li>
						                      <li className="separator">
						                        <i className="fas fa-chevron-right fourth_light_color"></i>
						                      </li>
		                                	  <li className="nav-item">
				                                  <a className=""> {selectedWindow} </a>
			                                  </li>
						                    </ul>
							            	{/*<ul className="breadcrumbs text-small">
						                      <li onClick={e=>goBackDrillDown(-1)}  className="nav-item">
						                        <a className=""> {windowFieldsBack ? windowFieldsBack.display_name : ''} </a>
						                      </li>
						                      <li className="separator">
						                        <i className="fas fa-chevron-right fourth_light_color"></i>
						                      </li>
						                    {
						                      drillData ?
						                          drillData.map((item,ind) => {
						                            return (
						                              <Wrp key={ind}>
						                                <li onClick={e=>goBackDrillDown(ind)}  className="nav-item">
						                                  <a className=""> {item.field_name} </a>
						                                </li>
						                                <li className="separator">
						                                <i className="fas fa-chevron-right fourth_light_color"></i>
						                                </li>
						                              </Wrp>
						                            )
						                          })
						                      : null
						                    }
						                    </ul>*/}
							            </div>
							            <div className="card-body pt-0 pb-0 fixedHeight">
							                <div className="card-list">
							                {
						                      windowFields ? 
					                            windowFields.map((arr,ind) => {
					                              return (
					                                <div key={ind}  className="w-100 d-flex align-items-center justify-content-center mb-1">
					                                  <div className="w-100 ">
					                                    <label className="w-100 d-flex align-items-center mb-0 cursor-pointer">
					                                      <input type="radio" 
					                                        name={"fields_"} 
					                                        value={arr.api_field_name} 
					                                        className=" "
					                                        disabled={arr.fields && arr.fields.length > 0 ? true : false}
					                                        onChange={e=>fieldChangeHandler(e,arr)}
					                                        checked={arr.api_field_name===fieldVal.toString().replace(/#n/g, "") ? true : false}
					                                       />
					                                        <span className="pl-3">{arr.field_name}</span>
					                                    </label>
					                                  </div>
					                                  {
					                                    arr.fields && arr.fields.length > 0 ?
					                                        <div>   
					                                            <a className="cursor-pointer" onClick={e=>drillDownNextLevel(JSON.stringify(arr))}>
					                                                <Icons iconType="IconArrowR" />
					                                            </a>
					                                        </div>
					                                    : null
					                                  }
					                                </div>
					                                )
					                            })  
					                          : null
						                    }
							                {
						                      /*windowFields && windowFields.fields_with_filters && windowFields.fields_with_filters.window_fields ? 
						                            windowFields.fields_with_filters.window_fields.map((arr,ind) => {
						                              return (
						                                <div key={ind}  className="w-100 d-flex align-items-center justify-content-center mb-1">
						                                  <div className="w-100 ">
						                                    <label className="w-100 d-flex align-items-center mb-0 cursor-pointer">
						                                      <input type="radio" 
						                                        name={"fields_"} 
						                                        value={arr.api_field_name} 
						                                        className=" "
						                                        onChange={e=>fieldChangeHandler(e,arr)}
						                                        checked={arr.api_field_name===fieldVal.toString().replace(/#n/g, "") ? true : false}
						                                       />
						                                        <span className="pl-3">{arr.field_name}</span>
						                                    </label>
						                                  </div>
						                                  {
						                                    arr.dependent_layout ?
						                                        <div>   
						                                            <a className="cursor-pointer" onClick={e=>drillDownNextLevel(JSON.stringify(arr))}>
						                                                <Icons iconType="IconArrowR" />
						                                            </a>
						                                        </div>
						                                    : null
						                                  }
						                                </div>
						                                )
						                            })  
						                          : null*/
						                    }
							                </div>
							            </div>
							        </div>
							    </div>

							    <div className="col-2 pr-0 pl-2">
	                                <div className="card mb-0">
	                                    <div className="card-header p-1">
	                                        <div className="card-title"> Operators </div>
	                                    </div>
	                                    <div className="card-body pt-0 pb-0 fixedHeight"> 
	                                        <div className="card-list">
	                                            <div className="w-100 d-flex align-items-center justify-content-between mb-2">
	                                                <div className="selectgroup selectgroup-secondary selectgroup-pills w-100">
	                                                    <label className="selectgroup-item w-100">
	                                                        <input 
	                                                            type="radio" 
	                                                            name="operator" 
	                                                            className="selectgroup-input"
	                                                            value="" 
	                                                            onChange={changeHandler}
                                                                checked={operator === "" ? true : false}
	                                                        />
	                                                        <span className="selectgroup-button selectgroup-button-icon"> None </span>
	                                                    </label>
	                                                </div>
	                                            </div>
	                                        { metaInfo && metaInfo.operators ?
	                                            metaInfo.operators.map((operatorCategoty,operetorInd) => {
	                                                return operatorCategoty.symbols.map((operetorItem,opIndex)=>{
	                                                    return (
	                                                        <div className="w-100 d-flex align-items-center justify-content-between mb-2" key={operetorInd+'-'+opIndex}>
	                                                            <div className="selectgroup selectgroup-secondary selectgroup-pills w-100">
	                                                                <label className="selectgroup-item w-100">
	                                                                    <input 
	                                                                        type="radio" 
	                                                                        name="operator" 
	                                                                        className="selectgroup-input"
	                                                                        value={operetorItem}
	                                                                        onChange={changeHandler}
	                                                                        checked={operetorItem === operator ? true : false}
	                                                                    />
	                                                                    <span className="selectgroup-button selectgroup-button-icon"> {operetorItem}  </span>
	                                                                </label>
	                                                            </div>
	                                                        </div>
	                                                    )
	                                                });
	                                            })
	                                        : null }
	                                        </div>
	                                    </div>
	                                </div>
	                            </div>

							    <div className="col-5 pl-2">
							        <div className="card mb-0">
							            <div className="card-header p-1"><div className="card-title">List of Output Fields</div>
							            	<ul className="breadcrumbs text-small">
						                      <li onClick={e=>goBackDrillDown(-1,true)}  className="nav-item">
						                        <a className=""> Fields</a>
						                      </li>
						                      <li className="separator">
						                        <i className="fas fa-chevron-right fourth_light_color"></i>
						                      </li>
		                                	  { drillData.map((item,ind) => {
								                  return (
								                    <Wrp key={ind}>
								                      <li onClick={e=>goBackDrillDown(ind,true)}  className="nav-item">
								                        <a className=""> {item.name?item.name:item.variable_name} </a>
								                      </li>
								                      <li className="separator">
								                      <i className="fas fa-chevron-right fourth_light_color"></i>
								                      </li>
								                    </Wrp>
								                  )
								                }) } 
						                    </ul>
							            </div>
							            <div className="card-body pt-0 pb-0 fixedHeight">
							                <div className="card-list">
							                {outputInnerFields && outputInnerFields.length > 0 ?
							                	outputInnerFields && outputInnerFields.length>0 ?
							                		outputInnerFields.map((outputFieldItem, outputFieldIndex) => {
							                			return (
							                				<div className="w-100 d-flex align-items-center justify-content-between mb-1">
										                        <div className="w-100">
										                            <label className="w-100 d-flex align-items-center mb-0 cursor-pointer">
									                            		<input type="radio" 
									                            			name="outputField" 
									                            			class=" " 
									                            			onChange={changeHandler}
									                            			value={outputFieldItem.api_name}
									                            			checked={outputField === outputFieldItem.api_name ? true : false}
									                            		 /> 
									                            		<span className="pl-3">{outputFieldItem.name}</span>
									                            	</label>
										                        </div>
										                        {
								                                    outputFieldItem.fields && outputFieldItem.fields.length > 0 ?
								                                        <div>   
								                                            <a className="cursor-pointer" onClick={e=>drillDownNextLevel(JSON.stringify(outputFieldItem),true)}>
								                                                <Icons iconType="IconArrowR" />
								                                            </a>
								                                        </div>
								                                    : null
								                                  }
										                    </div>
							                			)
							                		})
							                	: null
							                :	outputFields && outputFields.length>0 ?
							                		outputFields.map((outputFieldItem, outputFieldIndex) => {
							                			return (
							                				<div className="w-100 d-flex align-items-center justify-content-between mb-1">
										                        <div className="w-100">
										                            <label className="w-100 d-flex align-items-center mb-0 cursor-pointer">
									                            		<input type="radio" 
									                            			name="outputField" 
									                            			class=" " 
									                            			onChange={changeHandler}
									                            			value={outputFieldItem.api_name}
									                            			checked={outputField === outputFieldItem.api_name ? true : false}
									                            		 /> 
									                            		<span className="pl-3">{outputFieldItem.variable_name}</span>
									                            	</label>
										                        </div>
										                        {
								                                    outputFieldItem.fields && outputFieldItem.fields.length > 0 ?
								                                        <div>   
								                                            <a className="cursor-pointer" onClick={e=>drillDownNextLevel(JSON.stringify(outputFieldItem),true)}>
								                                                <Icons iconType="IconArrowR" />
								                                            </a>
								                                        </div>
								                                    : null
								                                  }
										                    </div>
							                			)
							                		})
							                	: null
							                }
							                </div>
							            </div>
							        </div>
							    </div>
							</div>



						</div>

						<div className="col-6 col-centered"><code> (Choose fields and) <span className="btn btn-link" onClick={addExpression}><i className="fas fa-angle-double-down"></i> Add Below </span> </code></div>


						<div className="col-12">
						    <div className="d-flex justify-content-between">
						        <div className={expression_error && expression_error === true ? "col-8 has-error" : "col-8"}>
						        	<textarea className="form-control" id={"expressText"} name="expression" onChange={changeHandler} value={expression ? expression : ''}> </textarea>
						        	{expression_error && expression_error === true ? 
                                        <label className="error m-0">Expression is empty</label>
                                        : null
                                    }
						        		<div className="col-4 col-centered"><code> <span className="btn btn-link" onClick={assignToKeywordToggleModel}><i className="fas fa-tasks"></i> Assign to keyword </span> </code></div>
						        </div>
						        <div className="col-4">
						            <h4 className="d-flex align-items-center justify-content-between"><span> Output Mapping Fields </span></h4>
						            {/*<select name="outputFieldMapping" className="form-control" onChange={changeHandler} value={outputFieldMapping}>
						                <option value=""></option>
						                { windowFields && windowFields.fields_with_filters && windowFields.fields_with_filters.window_fields ? 
				                            windowFields.fields_with_filters.window_fields.map((arr,ind) => {
				                              return <option key={ind} value={arr.id}>{arr.field_name}</option>
				                            })  
			                          : null }
						            </select>*/}
						            <DropDownSearch
										options={fieldOptions}
										values={outputFieldMapping}
										changeHandler={e=>select2ChangeHandler(e,"outputFieldMapping")}
									/>
						        </div>
						    </div>
						</div>
	

					</div>
				</div>
			</div>
		</div>
	)
}


export default InputConfig;